export {default as TabBadge} from './TabBadge';
